var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 19",
    style: {
      enableBackground: "new 0 0 25 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9B9B9B;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,0H3.1C1.4,0,0,1.5,0,3.3v12.4C0,17.5,1.4,19,3.1,19h18.8c1.7,0,3.1-1.5,3.1-3.3V3.3C25,1.5,23.6,0,21.9,0 z M23.4,15.7c0,0.9-0.7,1.7-1.6,1.7H3.1c-0.9,0-1.6-0.7-1.6-1.7V3.3c0-0.9,0.7-1.7,1.6-1.7h18.8c0.9,0,1.6,0.7,1.6,1.7V15.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.6,4.3l-8.1,7l-8.1-7C4.1,4,3.6,4.1,3.3,4.4S3.1,5.3,3.4,5.6L12,13c0.1,0.1,0.3,0.2,0.5,0.2 c0.2,0,0.4-0.1,0.5-0.2l8.6-7.4c0.3-0.3,0.4-0.8,0.1-1.2C21.4,4.1,20.9,4,20.6,4.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.555150d49acc68ace54c4f1ceb75a19f.svg";
export { ForwardRef as ReactComponent };